import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Input from '../../../components/Input';
import Spinner from '../../../components/Spinner';
import ConfirmModal from '../../../components/ConfirmModal';
import baseHelper from '../../../helpers/BaseHelper';
import storeActions from '../../../redux/futures/store/actions';
import * as types from '../../../redux/futures/store/types';

class BuyResource extends React.Component {
    static propTypes = {
        currentUser: PropTypes.object,
        currentStore: PropTypes.object,
        appCode: PropTypes.string,
        onCancel: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            packages: [],
            resourceTypes: [],
            packagesByType: {},
            selectedItems: [],
            pickingResourceType: '',
            pickingPackage: null,
            pickingLimitValue: '',
            pickingMonth: '',
            pickingPkgName: '',
            recieve_amount: '',
            note: '',
            loaderPackages: true
        };
        this.inputsRef = new Set();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.action === types.LIST_PACKAGE) {
            // console.log(' next propds', nextProps);
            this.setState({ loaderPackages: false });
            if (nextProps.status && nextProps.packages && nextProps.packages.length > 0) {
                // console.log('nextProps.packages : ', JSON.stringify(nextProps.packages));
                const packages = nextProps.packages.map((pkg) => {
                    // console.log('pkg : ', pkg);
                    const normalized = Object.assign({}, pkg);
                    if (!normalized.pkg_name) {
                        normalized.pkg_name = pkg.name || pkg.package_name || pkg.pkgName || pkg.packageName || '';
                    }
                    // Một số API trả resource_type ở nested field hoặc thiếu → giữ nguyên nếu có
                    if (!normalized.resource_type && pkg.type) {
                        normalized.resource_type = pkg.type;
                    }
                    // console.log('normalized : ', normalized);
                    return normalized;
                });
                // console.log('packages : ', packages);
                const packagesByType = _.groupBy(packages, 'resource_type');
                // console.log('packagesByType : ', packagesByType);
                const resourceTypes = Object.keys(packagesByType).filter(Boolean);

                this.setState({
                    packages,
                    packagesByType,
                    resourceTypes,
                    selectedItems: [],
                    pickingResourceType: '',
                    pickingPackage: null,
                    pickingLimitValue: '',
                    pickingMonth: '',
                    pickingPkgName: '',
                    recieve_amount: ''
                });
            } else {
                window.LadiUI.toastr('error', '', nextProps.message || 'Không có gói tài nguyên');
            }
        }

        if (nextProps.action === types.BUY_RESOURCE) {
            if (nextProps.status) {
                window.LadiUI.toastr('success', '', nextProps.message);
                window.LadiUI.closeModalById('modal-buy-resource');
                this.resetForm();
            } else {
                window.LadiUI.toastr('error', '', nextProps.message);
            }
        }
    }

    resetForm = () => {
        this.setState({
            packages: [],
            resourceTypes: [],
            packagesByType: {},
            selectedItems: [],
            pickingResourceType: '',
            pickingPackage: null,
            pickingLimitValue: '',
            pickingMonth: '',
            pickingPkgName: '',
            recieve_amount: '',
            note: '',
            loaderPackages: false
        });
    }

    getPkgName = (pkg) => {
        if (!pkg) return '';
        // Ưu tiên pkg_name; fallback theo convention của list-packages (name / package_name)
        return pkg.pkg_name || pkg.name || pkg.package_name || pkg.pkgName || pkg.packageName || '';
    }

    getPackageLabel = (pkg) => {
        // console.log(pkg);
        if (!pkg) return 'Chọn gói';
        const pkgName = this.getPkgName(pkg);
        const priceLabel = pkg.price ? `${pkg.price.toLocaleString('vi-VN')} VND` : '';
        if (pkgName && priceLabel) return `${pkgName} - ${priceLabel}`;
        if (pkgName) return pkgName;
        if (priceLabel) return `${pkg.resource_type} - ${priceLabel}`;
        return pkg.resource_type || 'Chọn gói';
    }

    isValidMonth = (resourceType, month) => {
        const monthNum = parseInt(month, 10);
        if (!monthNum || monthNum < 1) return false;
        if (resourceType === 'store') {
            return monthNum % 12 === 0;
        }
        return true;
    }

    getAvailableResourceTypes = () => {
        const { resourceTypes, selectedItems } = this.state;
        const usedTypes = selectedItems.map((item) => item.resource_type);
        return resourceTypes.filter((type) => usedTypes.indexOf(type) === -1);
    }

    calcItemTotalPrice = (pkg, limitValue, month) => {
        if (!pkg || !limitValue) return 0;
        if (pkg.resource_type === 'store') {
            return (pkg.price || 0);
        }
        return (pkg.price || 0) * parseInt(limitValue, 10) * parseInt(month, 10);
    }

    getSelectedItemsTotal = () => {
        return this.state.selectedItems.reduce((sum, item) => sum + (item.total_price || 0), 0);
    }

    syncRecieveAmount = (selectedItems) => {
        const total = selectedItems.reduce((sum, item) => sum + (item.total_price || 0), 0);
        this.setState({ recieve_amount: String(total) });
    }

    handlePickingResourceTypeChange = (resource_type) => {
        const { packagesByType, selectedItems } = this.state;
        const typePackages = packagesByType[resource_type] || [];
        const pickingPackage = typePackages[0] || null;
        const pkgName = this.getPkgName(pickingPackage);
        const storeItem = selectedItems.find((item) => item.resource_type === 'store');

        let pickingMonth = '';
        if (storeItem) {
            pickingMonth = String(storeItem.month);
        } else if (resource_type === 'store') {
            pickingMonth = '12';
        }

        this.setState({
            pickingResourceType: resource_type,
            pickingPackage,
            pickingLimitValue: pickingPackage ? String(pickingPackage.limit_value || '') : '',
            pickingPkgName: resource_type === 'store' ? pkgName : '',
            pickingMonth
        });
    }

    handlePickingPackageChange = (index) => {
        const { packagesByType, pickingResourceType } = this.state;
        const typePackages = packagesByType[pickingResourceType] || [];
        const pickingPackage = typePackages[index] || null;
        const pkgName = this.getPkgName(pickingPackage);

        this.setState({
            pickingPackage,
            pickingLimitValue: pickingPackage ? String(pickingPackage.limit_value || '') : '',
            pickingPkgName: pickingResourceType === 'store' ? pkgName : ''
        });
    }

    handleAddItem = () => {
        const {
            pickingPackage,
            pickingResourceType,
            pickingLimitValue,
            pickingMonth,
            pickingPkgName,
            selectedItems
        } = this.state;

        if (!pickingPackage || !pickingResourceType || !pickingLimitValue || !pickingMonth) {
            window.LadiUI.toastr('error', '', 'Vui lòng nhập đầy đủ thông tin item trước khi thêm');
            return;
        }

        if (selectedItems.some((item) => item.resource_type === pickingResourceType)) {
            window.LadiUI.toastr('error', '', 'Không được chọn trùng resource_type');
            return;
        }

        const pkgName = pickingPkgName || this.getPkgName(pickingPackage);
        if (pickingResourceType === 'store' && !pkgName) {
            window.LadiUI.toastr('error', '', 'Vui lòng nhập tên gói cho resource_type store');
            return;
        }

        if (!this.isValidMonth(pickingResourceType, pickingMonth)) {
            window.LadiUI.toastr('error', '', 'Với resource_type store, số tháng phải là bội số của 12');
            return;
        }

        // Nếu đã có item store, các item khác dùng cùng số tháng với store
        const storeItem = selectedItems.find((item) => item.resource_type === 'store');
        const month = storeItem ? String(storeItem.month) : String(pickingMonth);

        const newItem = {
            app_code: pickingPackage.app_code,
            resource_type: pickingResourceType,
            limit_value: String(pickingLimitValue),
            month,
            pkg_name: pickingResourceType === 'store' ? pkgName : '',
            price: pickingPackage.price || 0,
            total_price: this.calcItemTotalPrice(pickingPackage, pickingLimitValue, month),
            limit_type: pickingPackage.limit_type || ''
        };

        const nextItems = selectedItems.concat([newItem]);
        this.setState({
            selectedItems: nextItems,
            pickingResourceType: '',
            pickingPackage: null,
            pickingLimitValue: '',
            pickingMonth: '',
            pickingPkgName: ''
        }, () => {
            this.syncRecieveAmount(nextItems);
            this.reinitUI();
        });
    }

    handleRemoveItem = (index) => {
        const selectedItems = this.state.selectedItems.slice();
        selectedItems.splice(index, 1);
        this.setState({ selectedItems }, () => {
            this.syncRecieveAmount(selectedItems);
            this.reinitUI();
        });
    }
    reinitUI = () => {
        setTimeout(() => {
            if (window.LadiUI && typeof window.LadiUI.init === 'function') {
                window.LadiUI.init();
            }
        }, 0);
    }

    handleSelectedItemChange = (index, field, value) => {
        const selectedItems = this.state.selectedItems.slice();
        const item = Object.assign({}, selectedItems[index]);
        item[field] = value;

        if (field === 'limit_value') {
            item.total_price = (item.price || 0) * (parseInt(value, 10) || 0);
        }

        selectedItems[index] = item;
        this.setState({ selectedItems }, () => {
            if (field === 'limit_value') {
                this.syncRecieveAmount(selectedItems);
            }
        });
    }

    handleRecieveAmountChange = (e) => {
        this.setState({ recieve_amount: e.target.value });
    }

    handleNoteChange = (e) => {
        this.setState({ note: e.target.value });
    }

    handleSubmit = () => {
        const { currentUser } = this.props;
        const { selectedItems, recieve_amount, note } = this.state;

        if (!selectedItems.length) {
            window.LadiUI.toastr('error', '', 'Vui lòng thêm ít nhất 1 item');
            return;
        }

        for (let i = 0; i < selectedItems.length; i++) {
            const item = selectedItems[i];
            if (!item.app_code || !item.resource_type || !item.limit_value || !item.month) {
                window.LadiUI.toastr('error', '', 'Vui lòng nhập đầy đủ app_code, resource_type, limit_value, month cho mọi item');
                return;
            }
            if (item.resource_type === 'store' && !item.pkg_name) {
                window.LadiUI.toastr('error', '', 'Vui lòng nhập tên gói cho item store');
                return;
            }
            if (!this.isValidMonth(item.resource_type, item.month)) {
                window.LadiUI.toastr('error', '', 'Với resource_type store, số tháng phải là bội số của 12');
                return;
            }
        }

        const resourceTypes = selectedItems.map((item) => item.resource_type);
        if (_.uniq(resourceTypes).length !== resourceTypes.length) {
            window.LadiUI.toastr('error', '', 'Các item không được trùng resource_type');
            return;
        }

        const data = {
            ladi_uid: currentUser._id,
            recieve_amount: parseInt(recieve_amount, 10) || 0,
            note,
            items: selectedItems.map((item) => {
                const payload = {
                    app_code: item.app_code,
                    total_price: item.total_price,
                    resource_type: item.resource_type,
                    limit_value: parseInt(item.limit_value, 10),
                    month: parseInt(item.month, 10)
                };
                if (item.resource_type === 'store') {
                    payload.pkg_name = item.pkg_name;
                }
                return payload;
            })
        };
        this.props.buyResource(data);
    }

    renderStoreInfo = () => {
        const { currentStore } = this.props;
        if (!currentStore) return null;

        return (
            <div className="ladiui form-group">
                <div className="ladiui-row" style={{ height: '50px' }}>
                    <div className="col-50">
                        <strong>Tên gói: </strong>{currentStore.pkg_name || '--'}
                    </div>
                    <div className="col-50">
                        <strong>Ngày hết hạn: </strong>
                        {currentStore.pkg_exp ? baseHelper.formatStrToDate(currentStore.pkg_exp) : '--'}
                    </div>
                </div>
                {currentStore.name && (
                    <div className="ladiui-row" style={{ height: '50px' }}>
                        <div className="col-50">
                            <strong>Tên store: </strong>{currentStore.name}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    renderSelectedItems = () => {
        const { selectedItems } = this.state;
        if (!selectedItems.length) return null;

        return (
            <div className="ladiui form-group">
                <h4>Items đã chọn</h4>
                <table className="ladiui table">
                    <thead>
                        <tr>

                            {/* <th className="text-left">UID</th> */}
                            <th className="text-left">Loại tài nguyên</th>
                            <th className="text-left">Gói</th>
                            <th className="text-left">Số lượng</th>
                            <th className="text-left">Số tháng</th>
                            <th className="text-left">Giá</th>
                            <th className="text-left"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedItems.map((item, index) => (
                            <tr key={item.resource_type}>
                                <td>{item.resource_type}</td>
                                <td>{item.pkg_name}</td>
                                <td>{item.limit_value}</td>
                                <td>{item.month}</td>
                                <td>{item.total_price}</td>
                                <td> <button
                                    type="button"
                                    className="ladiui button secondary"
                                    onClick={() => this.handleRemoveItem(index)}
                                >
                                    Xóa
                                </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {/* {selectedItems.map((item, index) => (
                    <div key={item.resource_type} className="ladiui-card" style={{ marginBottom: '12px' }}>
                        <div className="ladiui-card-body">
                            <div className="ladiui-row" style={{ height: '40px' }}>
                                <div className="col-50">
                                    <strong>resource_type: </strong>{item.resource_type} {item.resource_type === 'store' ? ` - ${item.pkg_name}` : ''} {item.limit_value ? ` - ${item.limit_value}` : ''} {item.month ? ` - ${item.month}` : ''}
                                </div>
                                <div className="col-50 text-right">
                                    <button
                                        type="button"
                                        className="ladiui button secondary"
                                        onClick={() => this.handleRemoveItem(index)}
                                    >
                                        Xóa
                                    </button>
                                </div>
                            </div>

                            <div className="ladiui form-group">
                                <label className="ladiui-label">Số lượng (limit_value)</label>
                                <Input
                                    ref={(ref) => this.inputsRef.add(ref)}
                                    name={`limit_value_${index}`}
                                    validationName="Số lượng"
                                    placeholder="Số lượng"
                                    value={String(item.limit_value)}
                                    type="number"
                                    onChange={(e) => this.handleSelectedItemChange(index, 'limit_value', e.target.value)}
                                    validations={{ isRequired: true, min: 1 }}
                                />
                            </div>

                            <div className="ladiui form-group">
                                <label className="ladiui-label">Số tháng (month){item.resource_type === 'store' ? ' - bội số của 12' : ''}</label>
                                {item.resource_type === 'store' ? (
                                    <div className="ladiui-select-options">
                                        <span className="ladiui-select-init">{item.month || 'Chọn số tháng'}</span>
                                        <input type="hidden" name="select" defaultValue />
                                        <ul>
                                            {[12, 24, 36, 48, 60].map((m) => (
                                                <li key={m} className="select-item" onClick={() => this.handleSelectedItemChange(index, 'month', String(m))}>
                                                    <a href="#" data-value={m}>{m} tháng</a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ) : (
                                    <Input
                                        ref={(ref) => this.inputsRef.add(ref)}
                                        name={`month_${index}`}
                                        validationName="Số tháng"
                                        placeholder="Số tháng"
                                        value={String(item.month)}
                                        type="number"
                                        onChange={(e) => this.handleSelectedItemChange(index, 'month', e.target.value)}
                                        validations={{ isRequired: true, min: 1 }}
                                    />
                                )}
                            </div>

                            <div>
                                <strong>total_price: </strong>
                                {(item.total_price || 0).toLocaleString('vi-VN')} VND
                            </div>
                        </div>
                    </div>
                ))} */}
            </div>
        );
    }

    renderAddItemForm = () => {
        const {
            packagesByType,
            pickingResourceType,
            pickingPackage,
            pickingLimitValue,
            pickingMonth,
            pickingPkgName
        } = this.state;
        const availableTypes = this.getAvailableResourceTypes();

        const typePackages = packagesByType[pickingResourceType] || [];
        // console.log('packagesByType : ', packagesByType, '-typePackages ', typePackages);
        if (!availableTypes.length) {
            return (
                <div className="ladiui form-group">
                    <em>Tổng tiền tạm tính : {this.getSelectedItemsTotal().toLocaleString('vi-VN')} VND</em>
                </div>
            );
        }

        return (
            <div className="ladiui form-group">

                <div className="ladiui form-group">
                    <label className="ladiui-label">Loại tài nguyên</label>
                    <div className="ladiui-select-options" style={{ zIndex: 10 }}>
                        <span className="ladiui-select-init">{pickingResourceType || 'Chọn loại tài nguyên'}</span>
                        <input type="hidden" name="select" defaultValue />
                        <ul>
                            <li className="select-item" onClick={() => this.handlePickingResourceTypeChange('')}>
                                <a href="#" data-value="">Chọn loại tài nguyên</a>
                            </li>
                            {availableTypes.map((type) => (
                                <li key={type} className="select-item" onClick={() => this.handlePickingResourceTypeChange(type)}>
                                    <a href="#" data-value={type}>{type}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {typePackages.length > 0 && pickingResourceType && (
                    <div className="ladiui form-group">
                        <label className="ladiui-label">Chọn gói</label>
                        <div className="ladiui-select-options" style={{ zIndex: 22 }}>
                            <span className="ladiui-select-init">
                                {this.getPackageLabel(pickingPackage)}
                            </span>
                            <input type="hidden" name="select" defaultValue />
                            <ul>
                                {typePackages.map((pkg, index) => (
                                    <li key={index} className="select-item" onClick={() => this.handlePickingPackageChange(index)}>
                                        <a href="#" data-value={index}>
                                            {this.getPackageLabel(pkg)}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}

                {/* {pickingPackage && (
                    <div className="ladiui form-group">
                        <div className="ladiui-card">
                            <div className="ladiui-card-body">
                                <div className="ladiui-row" style={{ height: '40px' }}>
                                    <div className="col-50">
                                        <strong>Giá: </strong>
                                        {pickingPackage.price ? pickingPackage.price.toLocaleString('vi-VN') : '--'}
                                    </div>
                                    <div className="col-50">
                                        <strong>limit_type: </strong>{pickingPackage.limit_type || '--'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )} */}
                {
                    pickingResourceType !== 'store' &&
                    <div className="ladiui form-group">
                        <label className="ladiui-label">Số lượng (limit_value)</label>


                        <Input
                            ref={(ref) => this.inputsRef.add(ref)}
                            name="picking_limit_value"
                            validationName="Số lượng"
                            placeholder="Số lượng"
                            value={String(pickingLimitValue)}
                            type="number"
                            onChange={(e) => this.setState({ pickingLimitValue: e.target.value })}
                            disabled={!pickingResourceType}
                            validations={{ isRequired: true, min: 1 }}
                        />
                    </div>
                }

                <div className="ladiui form-group">
                    <label className="ladiui-label">
                        Số tháng (month){pickingResourceType === 'store' ? ' - bội số của 12' : ''}
                    </label>
                    {pickingResourceType === 'store' ? (
                        <div className="ladiui-select-options">
                            <span className="ladiui-select-init">{pickingMonth ? `${pickingMonth} tháng` : 'Chọn số tháng'}</span>
                            <input type="hidden" name="select" defaultValue />
                            <ul>
                                {[12, 24, 36, 48, 60].map((m) => (
                                    <li key={m} className="select-item" onClick={() => this.setState({ pickingMonth: String(m) })}>
                                        <a href="#" data-value={m}>{m} tháng</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <Input
                            ref={(ref) => this.inputsRef.add(ref)}
                            name="picking_month"
                            validationName="Số tháng"
                            placeholder="Số tháng"
                            value={String(pickingMonth)}
                            type="number"
                            onChange={(e) => this.setState({ pickingMonth: e.target.value })}
                            disabled={!pickingResourceType}
                            validations={{ isRequired: true, min: 1 }}
                        />
                    )}
                </div>

                {pickingResourceType === 'store' && (
                    <div className="ladiui form-group">
                        <label className="ladiui-label">Tên gói (pkg_name)</label>
                        <input
                            className="ladiui input"
                            type="text"
                            name="picking_pkg_name"
                            value={pickingPkgName}
                            readOnly={true}
                        />
                        {/* <Input
                            ref={(ref) => this.inputsRef.add(ref)}
                            name="picking_pkg_name"
                            validationName="Tên gói"
                            placeholder="Tên gói"
                            value={pickingPkgName}
                            onChange={(e) => this.setState({ pickingPkgName: e.target.value })}
                            validations={{ isRequired: true }}
                        /> */}
                    </div>
                )}

                <div className="ladiui form-group text-right">
                    <button
                        type="button"
                        className="ladiui button primary icon-c-add "
                        onClick={this.handleAddItem}
                        disabled={!pickingResourceType}
                    >
                        Thêm item
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const { recieve_amount, note, loaderPackages, selectedItems } = this.state;

        return (
            <div id="modal-buy-resource" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-buy-resource" style={{ zIndex: '22' }}>
                <div className="ladiui-modal-content">
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-buy-resource">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-buy-resource" />
                        </button>
                        <h3>Mua tài nguyên</h3>
                    </div>
                    <div className="ladiui-modal-body">
                        <div className="ladiui-form">
                            {this.renderStoreInfo()}
                            {this.renderSelectedItems()}
                            {this.renderAddItemForm()}

                            <div className="ladiui form-group">
                                <label className="ladiui-label">Số tiền thực nhận (recieve_amount)</label>
                                <Input
                                    ref={(ref) => this.inputsRef.add(ref)}
                                    name="recieve_amount"
                                    validationName="Số tiền thực nhận"
                                    placeholder="Số tiền thực nhận"
                                    value={String(recieve_amount)}
                                    type="number"
                                    onChange={this.handleRecieveAmountChange}
                                    validations={{ isRequired: true, min: 0 }}
                                />
                            </div>

                            <div className="ladiui form-group">
                                <label className="ladiui-label">Ghi chú (note)</label>
                                <textarea
                                    name="note"
                                    className="ladiui textarea"
                                    value={note}
                                    onChange={this.handleNoteChange}
                                    placeholder="Nội dung chuyển khoản"
                                />
                            </div>



                            <div className="ladiui form-group text-right">
                                <button
                                    className="ladiui button primary open-modal"
                                    modal="confirm-buy-resource"
                                    disabled={this.props.loading || !selectedItems.length || !recieve_amount}
                                >
                                    Mua tài nguyên
                                </button>
                            </div>
                        </div>
                        {(this.props.loading || loaderPackages) && <Spinner />}
                    </div>
                </div>
                <ConfirmModal
                    id="confirm-buy-resource"
                    title="Xác nhận mua tài nguyên?"
                    content="Bạn có chắc chắn muốn mua tài nguyên này?"
                    cancelText="Hủy"
                    okText="Mua"
                    onOk={this.handleSubmit}
                    isLoading={this.props.loading}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    packages: state.store.packages,
    loading: state.store.loading,
    action: state.store.action,
    status: state.store.status,
    message: state.store.message
});

const mapDispatchToProps = (dispatch) => ({
    buyResource: (data) => dispatch(storeActions.buyResource(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(BuyResource);
